import React from "react";
import SearchForm from "./SearchForm";
import SearchResultsDisplay from "./SearchResultsDisplay";
import { isClickInBox } from "utilities/js/ClickPositionHelper";
import Constants from "utilities/js/Constants";

const loadingIcon = Constants.ICON_LOADING;

class HomeSearchContainer extends React.Component {

    constructor(props){
        super(props);
        

        this.formContainerRef = React.createRef();

        this.state = {
            searchTerm: '',
            searchResults: this.props.searchResults,
            table: "bracket",

            displayLoginScreen: true,
            errorDisplay: '',
            resultsDisplayIsOpen: false
        };

        this.setSearchResults = this.setSearchResults.bind(this);
        this.getSearchResultsDisplay = this.getSearchResultsDisplay.bind(this);

    }


    componentDidMount() {
        document.addEventListener('click', this.closeResultsOnOutsideClick.bind(this));
    }

    /******************************* Input Setters  ************************************/

    setSearchResults(results){
        this.setState({searchResults: results, resultsDisplayIsOpen: true});
    }

    /*********************** Screen flow controls ***********************/

     
    closeResultsOnOutsideClick(event) {
        //TODO: evaluate because this may act strangely if multiple search inputs are on the same screen
        let searchBar = document.querySelector('.search-screen-content-container');
        let searchResults = document.querySelector('.search-results-container');
        if(searchResults){
            if (!isClickInBox(event.x, event.y, searchBar.getBoundingClientRect()) && !isClickInBox(event.x, event.y, searchResults.getBoundingClientRect())) {
                this.setState({resultsDisplayIsOpen: false})
            }
        }
    }



    /*********************** UI Render Helpers ***********************/
    loadingScreen(){
        if(this.state.isLoading){
            return (<div className="loading-icon-container"><img src={loadingIcon} alt="loading"></img></div>)
        }
        return;
    }

    getSearchResultsDisplay(){
        if(this.state.searchResults && this.state.resultsDisplayIsOpen){
            return (<SearchResultsDisplay table={this.state.searchResults.table} searchResults={this.state.searchResults.values}></SearchResultsDisplay>);
        }else{
            return <></>
        }
        
    }

    render(){
        return (
            <>
                {/* <SearchForm placeholder='Search bracket titles or @usernames...' callback={this.setSearchResults}></SearchForm> */}
                <SearchForm placeholder='Search bracket titles or @usernames...'></SearchForm>
                {this.getSearchResultsDisplay()}
            </>
        );
    }
}

export default HomeSearchContainer;
